import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { Boundaries } from "@planzone/core";
import { createSelector } from "./selector";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createCalendarHolidaysRequested]: setRequestStateToPending,
    [events.createCalendarHolidaysSucceeded]: setRequestStateToSuccess,
    [events.createCalendarHolidaysFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);
export type { State, Selector };

export { reduceState, initialState, createSelector };
